import { Checkbox, Modal, RadioGroup, Switch } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";
import { type ChangeEvent, useEffect, useState } from "react";

import { ENV_NAME } from "../common/environment";
import { type LogTag, logger, logTags } from "../common/logger";
import { getConfigCatLogLevelFromStorage, setConfigCatLogLevelInStorage } from "../common/utils/storage/loggerStorageUtils";
import uiStore from "../stores/uiStore";
import Divider from "./Divider";

const LoggerSettingsModal = () => {
   const [enabledTags, setEnabledTags] = useState<string[]>([]);
   const [allTagsEnabled, setAllTagsEnabled] = useState<boolean>(false);

   useEffect(() => {
      const currentEnabledTags = logger.getEnabledTags();
      setEnabledTags(currentEnabledTags);

      const allTagsAreEnabled = logTags.every((tag) => currentEnabledTags.includes(tag));
      setAllTagsEnabled(allTagsAreEnabled);
   }, [uiStore.showLoggerModal]);

   const toggleTag = (tag: LogTag) => {
      if (logger.isEnabled(tag)) {
         logger.disable(tag);
      } else {
         logger.enable(tag);
      }
      setEnabledTags(logger.getEnabledTags());
   };

   const toggleAllTags = () => {
      const newState = !allTagsEnabled;
      setAllTagsEnabled(newState);

      if (newState) {
         logger.enableAllTags();
         setEnabledTags(logger.getEnabledTags());
      } else {
         logger.disableAllTags();
         setEnabledTags([]);
      }
   };

   const configCatOptions = [
      { label: "Off", value: "-1" },
      { label: "Error", value: "1" },
      { label: "Warn & error", value: "2" },
      { label: "Info, warn & error", value: "3" },
      { label: "All", value: "4" }
   ];
   const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const level = e.target.value;
      setConfigCatLogLevelInStorage(level);
      alert(
         "ConfigCat-loggnivå er oppdatert. Refresh siden for at endringen skal tre i kraft (configCatClient må reinitialiseres)."
      );
   };

   return (
      <Modal
         size="xl"
         title="Innstillinger for logging"
         isOpen={uiStore.showLoggerModal}
         onClose={uiStore.toggleLoggerModal}
         className="bg-background-tinted"
      >
         <p className="mb-6">Velg hvilke tags du ønsker å aktivere for console-logging:</p>
         <div className="flex flex-row gap-4">
            <Switch isEnabled={allTagsEnabled} onChange={toggleAllTags} label="Skru på alle tags" />
         </div>

         <Divider />

         <ul className="flex flex-wrap gap-4">
            {logTags.map((tag) => (
               <li key={tag} className="mb-2 flex">
                  <Checkbox
                     isChecked={enabledTags.includes(tag)}
                     onChange={() => toggleTag(tag)}
                     aria-label={`Toggle logging for ${tag}`}
                     label={tag}
                     isDisabled={allTagsEnabled}
                  />
               </li>
            ))}
         </ul>
         {ENV_NAME !== "prod" && (
            <>
               <p className="mt-12">Velg nivå av logging for ConfigCat:</p>
               <RadioGroup
                  options={configCatOptions}
                  initialValue={getConfigCatLogLevelFromStorage()}
                  label=""
                  onChange={handleChange}
                  horizontal
               />
            </>
         )}
      </Modal>
   );
};

export default observer(LoggerSettingsModal);
